<script>
  import AutoComplete from "simple-svelte-autocomplete";
  import { onMount } from 'svelte';

  export let apiPath = "";
  export let endpoint = "";
  export let suggestByTitle = false;
  export let locale = "de";
  export let targetUrl = "";
  export let locales = {};
  let formTag;

  // legacy labels, should be removed but some project could have used them
  const translations = {
    de: {
      search: "Suchen",
      keywordSearch: "Stichwortsuche",
      noResultsText: "Keine Vorschläge vorhanden.",
      loadingText: "Ergebnisse werden geladen..."
    },
    en: {
      search: "search",
      keywordSearch: "keyword search",
      noResultsText: "No suggestions found.",
      loadingText: "Loading results..."
    },
  };

  function getLocale(key) {
    if (key in locales) {
      return locales[key];
    }
    let legacyLocales;
    if (locale in translations) {
      legacyLocales = translations[locale];
    } else {
      legacyLocales = translations.en;
    }
    return legacyLocales[key] || "";
  }

  /* validate GET params */
  // const searchParams = new URLSearchParams(location.search);

  let dcsearch = "";

  const handleSubmit = (event) => {
    event.target.submit();
  };

  async function getItems(keyword) {
    const url = suggestByTitle ? apiPath + "?suggestByTitle=1" : apiPath;
    let formData = new FormData();
    formData.append('search', keyword);
    formData.append('endpoint', endpoint);

    const response = await fetch(url, {
      method: 'POST',
      body: formData
    });

    const json = await response.json();
    let res = json[0]["suggest"].map(search => search.replaceAll('-', ' '));
    return res;
  }

  // We cannot use the "onChange" event, since it fires too early. 
  onMount(() => {
    formTag.querySelector(".dc-search-suggest-input").addEventListener("keyup", (event) => {
      if (event.key === "Enter") {
        formTag.submit();
      }
    });
  });  

</script>
<div class="searchBar">
  <form
    method="GET"
    action="{targetUrl}"
    on:submit|preventDefault={handleSubmit}
    bind:this={formTag}
  >
    <AutoComplete
      searchFunction={getItems}
      delay="200"
      localFiltering=false
      minCharactersToSearch=3
      placeholder={getLocale("keywordSearch")}
      hideArrow=true
      noResultsText={getLocale("noResultsText")}
      loadingText={getLocale("loadingText")}
      bind:selectedItem={dcsearch}
      name="dcsearch"
      className="dc-search-suggest"
      inputClassName="dc-search-suggest-input"
      dropdownClassName="dc-search-suggest-dropdown"
    />
    <div class="submit">
      <input
        class="button"
        type="submit"
        value={getLocale("search")}
      />
    </div>
  </form>
</div>

<style>
</style>
